import React from 'react';
import { Link } from 'react-router-dom';
import './LegalPages.css';

const TermsOfService = () => {
  return (
    <div className="legal-page">
      <header className="header">
        <div className="container">
          <div className="logo">
            <Link to="/">
              <h1>Heni</h1>
            </Link>
          </div>
          <nav className="nav">
            <Link to="/" className="back-link">← Back to Home</Link>
          </nav>
        </div>
      </header>

      <main className="legal-content">
        <div className="container">
          <h1>Terms of Service</h1>
          <p className="last-updated">Last updated: {new Date().toLocaleDateString()}</p>

          <section>
            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing and using Heni's AI avatar services, you accept and agree to be bound by the terms 
              and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
            </p>
          </section>

          <section>
            <h2>2. Description of Service</h2>
            <p>
              Heni provides AI-powered avatar companions that can chat, play games, and create content with users.
              Our service includes but is not limited to:
            </p>
            <ul>
              <li>Interactive AI avatar conversations</li>
              <li>Collaborative gaming experiences</li>
              <li>Creative content generation</li>
              <li>24/7 companionship and support</li>
            </ul>
            <p>
              To deliver these services, we utilize third-party platforms and technologies, including:
            </p>
            <ul>
              <li><strong>Supabase:</strong> For secure authentication, database management, and file storage</li>
              <li><strong>OpenAI:</strong> For powering AI-driven conversations and language processing</li>
              <li><strong>Replicate:</strong> For additional AI capabilities including image generation and other AI services</li>
            </ul>
            <p>
              By using our service, you acknowledge that your data may be processed by these third-party providers
              as necessary to deliver our services. These providers are bound by their own terms of service and
              privacy policies.
            </p>
          </section>

          <section>
            <h2>3. User Accounts</h2>
            <p>
              To access certain features of our service, you may be required to create an account. You are responsible for:
            </p>
            <ul>
              <li>Maintaining the confidentiality of your account credentials</li>
              <li>All activities that occur under your account</li>
              <li>Providing accurate and complete information</li>
              <li>Promptly updating your account information</li>
            </ul>
          </section>

          <section>
            <h2>4. Acceptable Use</h2>
            <p>You agree not to use the service to:</p>
            <ul>
              <li>Violate any applicable laws or regulations</li>
              <li>Harass, abuse, or harm other users</li>
              <li>Transmit harmful, offensive, or inappropriate content</li>
              <li>Attempt to gain unauthorized access to our systems</li>
              <li>Use the service for commercial purposes without permission</li>
              <li>Impersonate others or provide false information</li>
            </ul>
          </section>

          <section>
            <h2>5. Intellectual Property</h2>
            <p>
              The service and its original content, features, and functionality are and will remain the exclusive 
              property of Heni and its licensors. The service is protected by copyright, trademark, and other laws.
            </p>
          </section>

          <section>
            <h2>6. User Content</h2>
            <p>
              You retain ownership of content you create or share through our service. However, by using our service, 
              you grant us a license to use, modify, and display your content as necessary to provide our services.
            </p>
          </section>

          <section>
            <h2>7. Privacy</h2>
            <p>
              Your privacy is important to us. Please review our Privacy Policy, which also governs your use of 
              the service, to understand our practices.
            </p>
          </section>

          <section>
            <h2>8. Disclaimers</h2>
            <p>
              The service is provided on an "as is" and "as available" basis. We make no warranties, expressed or 
              implied, and hereby disclaim all other warranties including, without limitation, implied warranties 
              or conditions of merchantability, fitness for a particular purpose, or non-infringement.
            </p>
          </section>

          <section>
            <h2>9. Limitation of Liability</h2>
            <p>
              In no event shall Heni, its directors, employees, or agents be liable for any indirect, incidental, 
              special, consequential, or punitive damages, including without limitation, loss of profits, data, 
              use, goodwill, or other intangible losses.
            </p>
          </section>

          <section>
            <h2>10. Termination</h2>
            <p>
              We may terminate or suspend your account and bar access to the service immediately, without prior 
              notice or liability, under our sole discretion, for any reason whatsoever, including without limitation 
              if you breach the Terms.
            </p>
          </section>

          <section>
            <h2>11. Changes to Terms</h2>
            <p>
              We reserve the right to modify or replace these Terms at any time. If a revision is material, we will 
              provide at least 30 days notice prior to any new terms taking effect.
            </p>
          </section>

          <section>
            <h2>12. Governing Law</h2>
            <p>
              These Terms shall be interpreted and governed by the laws of [Your Jurisdiction], without regard to 
              its conflict of law provisions.
            </p>
          </section>

          <section>
            <h2>13. Contact Information</h2>
            <p>
              If you have any questions about these Terms of Service, please contact us at:
            </p>
            <div className="contact-info">
              <p>Email: info@heniapp.ai</p>
            </div>
          </section>
        </div>
      </main>

      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-links">
              <Link to="/">Home</Link>
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/terms">Terms of Service</Link>
            </div>
            <p>&copy; 2024 Heni. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default TermsOfService; 